import React from 'react';
import { LANGUAGES_ABBREVIATION } from '@/helpers/constants';
import CustomRichText from './CustomRichText';
import styles from './CustomRichText.module.scss';

interface DoubleTranslatedCustomRichTextProps {
  id: string;
  title: string;
  initialValue?: { [key: string]: { EN: string; DE: string } };
  handleInputChange: (lang: string, newValue: string) => void;
}

const DoubleTranslatedCustomRichText: React.FC<DoubleTranslatedCustomRichTextProps> = ({
  id,
  title,
  initialValue,
  handleInputChange,
}) => {
  return (
    <div className={styles.FieldText}>
      {LANGUAGES_ABBREVIATION.map((lang) => (
        <div className={styles.RichText} key={`key-${lang}`}>
          <CustomRichText
            language={lang}
            handleChange={(newValue) => handleInputChange(lang, newValue)}
            id={`${id}-${lang}`}
            initialValue={initialValue?.[lang] ?? ''}
            title={`${title}-${lang}`}
          />
        </div>
      ))}
    </div>
  );
};

export default DoubleTranslatedCustomRichText;
